import React from "react";
import styles from './CloudSelector.module.scss'
import Icon from "../../../../../components/Icon";
import * as config from "../../../../../settings/global";

function CloudSelector({clouds, selectCloud}) {
    return (
        <div>
            <ul className={styles.list}>
                {
                    clouds.map((cloud, index) => {

                        let icon = null;

                        if (!!config.DEBUG && (!!cloud.lock || !cloud['impl'])) {
                            icon = `fas fa-${!!cloud.lock ? "code" : "angle-double-up"}`;
                        }

                        return (
                            <li
                                className={styles.cloud}
                                onClick={() => selectCloud(cloud)}
                                key={index}
                            >
                                <div className={styles.cloud__icon}>
                                    <Icon
                                        className={styles.cloud__icon__image}
                                        icon={cloud.icon}
                                    />
                                </div>
                                <p className={styles.cloud__name}>{cloud.name}</p>
                                {
                                    !!icon &&
                                    <i className={`${icon} ${styles.cloud__dev}`} aria-hidden='false'/>
                                }
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default CloudSelector